import * as React from 'react';

import { createIcon } from '../Icon';
export const CpuIcon = createIcon(
  <React.Fragment>
    <rect height={16} rx={2} ry={2} width={16} x={4} y={4} />
    <rect height={6} width={6} x={9} y={9} />
    <line x1={9} x2={9} y1={1} y2={4} />
    <line x1={15} x2={15} y1={1} y2={4} />
    <line x1={9} x2={9} y1={20} y2={23} />
    <line x1={15} x2={15} y1={20} y2={23} />
    <line x1={20} x2={23} y1={9} y2={9} />
    <line x1={20} x2={23} y1={14} y2={14} />
    <line x1={1} x2={4} y1={9} y2={9} />
    <line x1={1} x2={4} y1={14} y2={14} />
  </React.Fragment>,
  'CpuIcon'
);
